<template>
  <div class="col-12">
    <div class="card-body px-0 pb-2 ">
      <div class="row justify-content-center">
        <div class="">
          <div class="p-4">
            <form @submit.prevent="handleSubmit" @keydown.enter.prevent>
              <div class="mb-4">
                <label class="form-label">{{ $t('chapters.name') }}</label>
                <input
                  type="text"
                  class="form-control borderless-input"
                  :class="{ 'is-invalid': errors.name }"
                  v-model.trim="formData.name"
                  required
                  @blur="validateField('name')"
                />
                <div class="invalid-feedback">{{ errors.name }}</div>
              </div>

              <div class="mt-4 d-flex gap-2">
                <button
                  type="submit"
                  class="btn btn-primary btn-sm flex-grow-1"
                  :disabled="loading || !hasChanges"
                >
                  <span v-if="loading">
                    <i class="fas fa-spinner fa-spin me-2"></i>
                    {{ $t('common.saving') }}
                  </span>
                  <span v-else>
                    <i :class="isEditMode ? 'fas fa-edit me-2' : 'fas fa-save me-2'"></i>
                    {{ submitText || $t('common.saveChanges') }}
                  </span>
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm flex-grow-1"
                  @click="handleCancel"
                  :disabled="loading"
                >
                  <i class="fas fa-times me-2"></i>
                  {{ $t('common.cancel') }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, watch, defineEmits, defineProps, onMounted, computed } from "vue";
import { useToast } from "vue-toastification";
import { useI18n } from "vue-i18n";
import api from "@/api";

const { t } = useI18n(); 
const props = defineProps({
  title: String,
  submitText: { type: String, default: "" },
  loading: { type: Boolean, default: false },
  isEditMode: { type: Boolean, default: false },
  initialData: { type: Object, default: () => ({ name: "", subjects: [] }) },
});

const emit = defineEmits(['submit', 'cancel', 'validation-error', 'update:form-data']);
const toast = useToast();

const formData = ref({ ...props.initialData });
const errors = ref({});
const subjects = ref([]);

const fetchSubjects = async () => {
  try {
    const response = await api.get('/subjects');
    subjects.value = response.data.data;
  } catch (error) {
    toast.error(t("form.fetchSubjectsError")); // بدل النص العربي الثابت
    console.error("Error fetching subjects:", error);
  }
};

const hasChanges = computed(() => formData.value.name !== props.initialData.name);

const validateField = (field) => {
  if (!formData.value[field]) {
    errors.value[field] = t("validation.required"); // نصوص ثنائية اللغة
    return false;
  }
  delete errors.value[field];
  return true;
};

const validateForm = () => {
  errors.value = {};
  const validations = [validateField('name')];
  return validations.every(valid => valid);
};

const handleSubmit = () => {
  if (!validateForm()) {
    emit('validation-error');
    toast.warning(t("validation.fixErrors")); // نص ثنائي اللغة
    return;
  }
  emit('submit', formData.value);
};

const handleCancel = () => emit('cancel');

watch(() => props.initialData, (newData) => {
  formData.value = { 
    ...newData,
    subjects: Array.isArray(newData.subjects) ? newData.subjects.map(s => s.id) : []
  };
}, { immediate: true, deep: true });

watch(formData, (newVal) => emit('update:form-data', newVal), { deep: true });

onMounted(fetchSubjects);
</script>
